import $ from 'jquery';
import Api from '../utilities/Api';
import Popup from '../utilities/Popup';
import {Cookie} from '../utilities';

$('.js-form-account-verify').submit(async function (e) {
    e.preventDefault();

    const $form = $(this);
    const isSmsForm = $form.attr('id') === 'smsForm';

    $form.find('.button').text('Подтверждение...');
    const data = $form.serializeObject();
    const isRef = Cookie.get('REF_REGISTER_WAS');

    await Api.post('/api/v2/account/verify/', data).then((response) => {
        if (response.isError) {
            if (isSmsForm) {

                $form.find('.error-message').remove();

                $form.find('input').last().after(`<div class="error-message" style="color: red;margin-top: 10px; margin-left: 5px;">${response.error}</div>`);
            } else {
                Popup.showContent('Ошибка', response.error, 700, true);
            }
        }
        if (response.isSuccess) {
            if(isRef === 'client'){
                Popup.showContent('Успешно', 'Поздравляем! Вы стали Привилегированным клиентом. Для Вас доступны скидки и промопредложения!', 700, true);
            }else{
                Popup.showContent('Успешно', 'Регистрация личного кабинета прошла успешно', 700, true);
            }

            const isOrdersPage = window.location.pathname === '/order/';


            if (isOrdersPage) {
                setTimeout(() => {
                    console.log('registered');
                    window.location.reload();
                }, 4000);
            }
            else if (response.isRedirectToBonus) {
                setTimeout(() => {
                    window.location.href = decodeURIComponent('/personal/cashback');
                }, 4000);
            } else if (response.isRedirectToCatalog) {
                window.location.href = decodeURIComponent('/catalog/');
            } else {
                setTimeout(() => {
                    window.location.href = decodeURIComponent(Cookie.get("LAST_VISITED_PAGE") || '/personal/orders/');
                }, 4000);
            }
        }
    });

    $form.find('.button').text('Подтвердить');
});
